import {
  createNativeEventConfig,
  getNativeBridge,
  isNative,
} from './native-bridge';
import { logd } from './utils';

interface NativeBridgeScaling {
  uiConfiguration:
    | {
        getFontScale:
          | ((options?: { eventConfig: unknown }) => Promise<{
              fontScale: number;
            }>)
          | undefined;
        setFontScaleOverride:
          | ((options: { fontScale: number | null }) => Promise<void>)
          | undefined;
      }
    | undefined;
}

type NativeBridgeScalingWindow = ReturnType<
  typeof getNativeBridge<NativeBridgeScaling>
>;

const isFontScaleAvailableOnNativeBridge = (
  nativeBridge: Partial<NativeBridgeScaling>,
): nativeBridge is NativeBridgeScaling => {
  return (
    isNative() &&
    !!nativeBridge?.uiConfiguration?.getFontScale &&
    !!nativeBridge?.uiConfiguration?.setFontScaleOverride
  );
};

const getNativeBridgeFont = (): NativeBridgeScalingWindow =>
  getNativeBridge<NativeBridgeScaling>();

export const isFontScaleAvailable = (): boolean =>
  isFontScaleAvailableOnNativeBridge(getNativeBridgeFont());

export const bootstrapFontScale = () => {
  if (!isFontScaleAvailable()) {
    return;
  }

  getFontScale()
    .then((fontScale) => {
      console.log({ fontScale });
      applyFontScale(fontScale);
    })
    .catch((error) => console.error(error));
};

export function getFontScale(): Promise<number> {
  return new Promise((resolve) => {
    const defaultValue = 1;
    const nb = getNativeBridgeFont();

    if (!isFontScaleAvailableOnNativeBridge(nb)) {
      resolve(defaultValue);
      return;
    }

    const eventConfig = createNativeEventConfig('font-scale');

    nb.uiConfiguration
      .getFontScale({ eventConfig })
      .then(({ fontScale }: { fontScale: number }) => resolve(fontScale))
      .catch((error: Error) => {
        resolve(defaultValue);
        logd(() => console.error('Error getting fontScale:', error));
      });
  });
}

const applyFontScale = (fontScale: number): void => {
  if (!isFontScaleAvailable()) {
    logd(() => console.error('fontScale is not available'));
    return;
  }

  const element = document.querySelector('meta[name=viewport]');

  if (element) {
    element.setAttribute(
      'content',
      `width=100, minimum-scale=${fontScale}, initial-scale=${fontScale}, maximum-scale=${fontScale}, user-scalable=yes, viewport-fit=cover`,
    );
  }
};
